import React from 'react'
import { PlacesType, Tooltip } from 'react-tooltip';

type Props = {    
    target: string,
    children?: JSX.Element,
    position?: PlacesType,
    bgColor?: string,
    
}
export const ToolTips = ({target, children, position, bgColor}: Props) => {
    return  <Tooltip id={target} style={{borderRadius: 5, backgroundColor: bgColor ? bgColor: '', zIndex: 1000000000, position: 'fixed'}}>
                {children &&
                    children
                }
            </Tooltip>
}